import React, { Fragment } from 'react';
import { ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Separator } from 'src/components/Separator';
import { PlatformPadding } from 'src/components/PlatformPadding';
import {
  Title1,
  Title2,
  Title3,
  Headline,
  Text,
  Subheading,
  Caption1,
  Caption2,
  Caption3,
  Caption4,
} from 'src/components/Typography';

storiesOf('Typography', module).add('Default', () => (
  <Fragment>
    <PanelHeader>📚 Typography</PanelHeader>
    <PlatformPadding vertical horizontal>
      <ScrollView>
        <PlatformPadding vertical>
          <Title1 weight="semibold">Title 1 Semibold 24/28</Title1>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Title1 weight="bold">Title 1 Bold 24/28</Title1>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Title2 weight="regular">Title 2 Regular 20/24</Title2>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Title2 weight="semibold">Title 2 Semibold 20/24</Title2>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Title3 weight="regular">Title 3 Regular 17/22</Title3>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Title3 weight="medium">Title 3 Medium 17/22</Title3>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Title3 weight="semibold">Title 3 Semibold 17/22</Title3>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Headline weight="regular">Headline Regular 16/20</Headline>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Headline weight="medium">Headline Medium 16/20</Headline>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Headline weight="semibold">Headline SemiBold 16/20</Headline>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Text weight="regular">Text Regular 15/20</Text>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Text weight="medium">Text Medium 15/20</Text>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Text weight="semibold">Text SemiBold 15/20</Text>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Subheading weight="regular">Subheading Regular 14/18</Subheading>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Subheading weight="medium">Subheading Medium 14/18</Subheading>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Subheading weight="semibold">Subheading SemiBold 14/18</Subheading>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Subheading weight="bold">Subheading Bold 14/18</Subheading>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Caption1 weight="regular">Caption 1 Regular 13/16</Caption1>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption1 weight="medium">Caption 1 Medium 13/16</Caption1>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption1 weight="semibold">Caption 1 SemiBold 13/16</Caption1>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption1 weight="semibold" uppercase>
            Caption Caps 1 SemiBold 13/16
          </Caption1>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Caption2 weight="regular">Caption 2 Regular 12/14</Caption2>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption2 weight="medium">Caption 2 Medium 12/14</Caption2>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption2 weight="semibold">Caption 2 SemiBold 12/14</Caption2>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption2 weight="semibold" uppercase>
            Caption Caps 2 SemiBold 12/14
          </Caption2>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Caption3 weight="regular">Caption 3 Regular 11/14</Caption3>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption3 weight="semibold" uppercase>
            Caption Caps 3 SemiBold 11/14
          </Caption3>
        </PlatformPadding>
        <Separator />
        <PlatformPadding vertical>
          <Caption4 weight="regular">Caption 3 Regular 9/12</Caption4>
        </PlatformPadding>
        <PlatformPadding vertical>
          <Caption4 weight="bold" uppercase>
            Caption Caps 4 SemiBold 9/12
          </Caption4>
        </PlatformPadding>
      </ScrollView>
    </PlatformPadding>
  </Fragment>
));
